import React from "react";
import { Modal } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useContactUsStyles } from "./ContactUs.styles";
import { ReactComponent as SuccessIcon } from "../../assets/contactUsSuccess.svg";

interface Props {
  open: boolean;
  onClose: () => void;
}

export const ContactUsSuccessModal: React.FC<Props> = ({ open, onClose }) => {
  const { t } = useTranslation();
  const classes = useContactUsStyles();

  return (
    <Modal open={open} onClose={onClose}>
      <div className={classes.successWrapper}>
        <div className={classes.headerRow}>
          <div className={classes.title}>{t("contact.successTitle")}!</div>
          <div className={classes.closeBtn} onClick={onClose}>
            ✕
          </div>
        </div>
        <SuccessIcon className={classes.successImg} />
        <button className={classes.successModalubmitBtn} onClick={onClose}>
          {t("contact.close")}
        </button>
      </div>
    </Modal>
  );
};
